exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:850px){#userName[data-v-579b8f1b]{display:none}}#overlay[data-v-579b8f1b]{position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;background:rgba(0,0,0,.3);text-align:center;font-size:35px;z-index:100000}.profile-photo[data-v-579b8f1b]{width:1.5rem;height:1.5rem;margin:-.375rem 0}.container[data-v-579b8f1b]{width:100%!important;max-width:100%!important}li[data-v-579b8f1b]{height:40px;padding:4px 8px!important}a[data-v-579b8f1b]{height:32px;line-height:32px;padding:0 4px}.brand-image[data-v-579b8f1b]{height:60px;position:absolute;left:0;top:0;padding:6px;background-color:#fff!important;border-bottom-right-radius:6px;z-index:10}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-579b8f1b","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Navbar.vue
// module id = bqsf
// module chunks = 29